import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button, Form, Input, message, Modal, Select, Typography } from "antd";
import { createManualWalletDebit } from "../api";

const { Option } = Select;

const ManualDebitHandler = ({ creatorId, creatorName, onSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const data = {
        userId: creatorId,
        amount: values.amount,
        description: values.description,
        currency: values.currency,
        category: values.category,
      };
      const resp = await createManualWalletDebit(data);
      if (resp?.code === 0) {
        message.success("Manual debit created successfully");
        setVisible(false);
        form.resetFields();
        if (onSuccess) {
          onSuccess();
        }
      } else {
        message.error(resp?.message || "Failed to create manual debit");
      }
    } catch (err) {
      console.error(err);
      message.error(err?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" onClick={() => setVisible(true)}>
        Add Manual Debit
      </Button>

      <Modal
        title={<Typography>Add Manual Debit for {creatorName}</Typography>}
        visible={visible}
        onCancel={() => {
          setVisible(false);
          form.resetFields();
        }}
        footer={[
          <Button key="cancel" onClick={() => setVisible(false)}>
            Cancel
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={{
            currency: "INR",
          }}
        >
          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              { required: true, message: "Please enter the amount" },
              {
                pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
                message: "Please enter a valid amount (up to 2 decimal places)",
              },
            ]}
          >
            <Input type="number" placeholder="Enter amount" />
          </Form.Item>

          <Form.Item
            name="currency"
            label="Currency"
            rules={[{ required: true, message: "Please select currency" }]}
          >
            <Select placeholder="Select currency">
              <Option value="INR">INR</Option>
              <Option value="USD">USD</Option>
              <Option value="EUR">EUR</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="category"
            label="Category"
            rules={[{ required: true, message: "Please select category" }]}
          >
            <Select placeholder="Select category">
              <Option value="manual_debit_tds">TDS</Option>
              <Option value="manual_debit_gst">GST</Option>
              <Option value="manual_debit_tcs">TCS</Option>
              <Option value="manual_debit_disputes">Disputes</Option>
              <Option value="manual_debit">Manual Debit</Option>
            </Select>
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true, message: "Please enter a description" }]}
          >
            <Input.TextArea
              rows={4}
              placeholder="Enter reason for manual debit"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

ManualDebitHandler.propTypes = {
  creatorId: PropTypes.string.isRequired,
  creatorName: PropTypes.string.isRequired,
  onSuccess: PropTypes.func,
};

export default ManualDebitHandler;
